<template>
  <div id="hres83e-reserve" class="hres83e-reserve">
    <div class="hrms-staappr">
      <div class="header-paper clearfix">
        <div class="header-left">
          <div class="box-header-label">
            <div class="header-label-ico"><i class="fa fa-users"></i> {{ labels['HREP83EC2']['10'] }}</div>
            <div class="header-label-data">: {{ indexSelected.assetno }} - {{ indexSelected.desc_assetno }}</div>
          </div>
          <div class="box-header-label">
            <div class="header-label-ico"><i class="fa fa-calendar"></i> {{ labels['HREP83EC2']['20'] }}</div>
            <div class="header-label-data">: {{ indexSelected.desc_typasset }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="box-func">
      <div class="box-topic border-color-skin">
        <i class="fa fa-pencil margin-r-5 color-skin"></i>
        <label class="color-skin">{{ descCodapp }}</label>
      </div>

      <div class="box-body">
        <div class="col-md-12">
          <div class="row">
            <div class="clearfix form-group">
              <label>{{ labels['HREP83EC2']['30'] }}</label>
              <hrms-datepicker  disabled="disabled"
                                v-model="detail.dtereq"
                                name="dtereq" />
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="row">
            <div class="clearfix form-group">
              <label>{{ labels['HREP83EC2']['40'] }}</label>
              <div class="">
                <div class="col-xs-6 clear-padding">
                  <div class="form-group">
                    <label>{{ labels['HREP83EC2']['50'] }} <span class="red">*</span></label>
                    <hrms-datepicker  v-model="detail.dtereserv"
                                      v-validate="'required|date_format:DD/MM/YYYY'"
                                      data-vv-value-path="inputDate"
                                      name="dtereserv"
                                      :disabled="eventDetail === 'edit'"
                                      :has-error="errors.has('dtereserv')" />
                    <div class="text-error" v-show="errors.has('dtereserv')">{{ errors.first('dtereserv') }}</div>
                  </div>
                </div>
                <div class="col-xs-6 clear-padding">
                  <div class="form-group">
                    <label>{{ labels['HREP83EC2']['60'] }} <span class="red">*</span></label>
                    <hrms-datepicker  v-model="detail.dteresere"
                                      v-validate="'required|date_format:DD/MM/YYYY'"
                                      data-vv-value-path="inputDate"
                                      name="dteresere"
                                      :disabled="eventDetail === 'edit'"
                                      :has-error="errors.has('dteresere')" />
                    <div class="text-error" v-show="errors.has('dteresere')">{{ errors.first('dteresere') }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="row">
            <div class="clearfix form-group">
              <div class="">
                <div class="col-xs-6 clear-padding">
                  <div class="form-group">
                    <label>{{ labels['HREP83EC2']['70'] }} <span class="red">*</span></label>
                    <hrms-timepicker  v-model="detail.timstrt"
                                      v-validate="'required|date_format:HH:mm'"
                                      data-vv-name="timstrt"
                                      data-vv-value-path="inputTime"
                                      name="timstrt"
                                      :class="{ 'input-error' : errors.has('timstrt') }"
                                      :has-error="errors.has('timstrt')" />
                    <div class="text-error" v-show="errors.has('timstrt')">{{ errors.first('timstrt') }}</div>
                  </div>
                </div>
                <div class="col-xs-6 clear-padding">
                  <div class="form-group">
                    <label>{{ labels['HREP83EC2']['80'] }} <span class="red">*</span></label>
                    <hrms-timepicker  v-model="detail.timend"
                                      v-validate="'required|date_format:HH:mm'"
                                      data-vv-name="timend"
                                      data-vv-value-path="inputTime"
                                      name="timend"
                                      :class="{ 'input-error' : errors.has('timend') }"
                                      :has-error="errors.has('timend')" />
                    <div class="text-error" v-show="errors.has('timend')">{{ errors.first('timend') }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="row">
            <div class="form-group">
              <label>{{ labels['HREP83EC2']['90'] }}</label>
              <textarea class="form-control" 
                        v-model="detail.remark"
                        name="remark" 
                        id="remark" 
                        maxlength="250"
                        v-validate="'max:250'"
                        data-vv-name="remark"
                        :has-error="errors.has('remark')"></textarea>
              <div class="text-error" v-show="errors.has('remark')">{{errors.first('remark')}}</div>
              <div class="remark-limit-character">{{ dispLimitLabel(250) }}</div> 
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="row">
            <div class="form-group">
              <label>{{ labels['HREP83EC2']['100'] }} <span class="red">*</span></label>
              <div class="row">
                <div class="form-group">
                  <div class="radio col-xs-12">
                    <label>
                      <input  type="radio" 
                              value="B" 
                              v-model="detail.staappr">
                      {{ labels['HREP83EC2']['110'] }} 
                    </label>
                  </div>
                  <div class="radio col-xs-12">
                    <label>
                      <input  type="radio" 
                              value="C" 
                              v-model="detail.staappr">
                      {{ labels['HREP83EC2']['120'] }} 
                    </label>
                    <input type="hidden" 
                            v-model="detail.staappr"
                            v-validate="'required'"
                            data-vv-name="staappr"
                            :has-error="errors.has('staappr')">
                    <div class="text-error" v-show="errors.has('staappr')">{{ errors.first('staappr') }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        
      </div>

      <div class="box-footer">
          <!-- Sumit Button -->
          <button type="button" class="btn bg-dark-gray" @click="toggle('detail')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
          <button type="button" class="btn bg-color-skin" @click="callSave()"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hres83e-reserve',
  props: [ 'labels', 'eventDetail', 'toggle', 'nowLang', 'labelsButton', 'descCodapp', 'dateSelected', 'indexSelected', 'calendarSelected', 'searchIndex', 'detail', 'currentUser', 'reserveYear', 'reserveMonth', 'postHres83eReserveSave' ],
  data () {
    return {
      app: this.$parent.$parent.$parent.$parent
    }
  },
  watch: {
    'detail.dtereserv' () {
      this.$validator.validate('dtereserv', this.detail.dtereserv).catch(e => {})
    },
    'detail.dteresere' () {
      this.$validator.validate('dteresere', this.detail.dteresere).catch(e => {})
    },
    'detail.timstrt' () {
      this.$validator.validate('timstrt', this.detail.timstrt).catch(e => {})
    },
    'detail.timend' () {
      this.$validator.validate('timend', this.detail.timend).catch(e => {})
    },
    'detail.staappr' () {
      this.$validator.validate('staappr', this.detail.staappr).catch(e => {})
    },
    'detail.remark' () {
      this.$validator.validate('remark', this.detail.remark).catch(e => {})
    },
    detail () {
      this.$nextTick(function () {
        this.errors.clear()
      })
    }
  },
  methods: {
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    saveParams () {
      return {
        assetno: this.indexSelected.assetno,
        dteyear: this.reserveYear,
        dtemonth: this.reserveMonth,
        codempid: this.currentUser,
        dtereserv: this.detail.dtereserv,
        dteresere: this.detail.dteresere,
        seqno: this.detail.seqno,
        timstrt: this.detail.timstrt,
        timend: this.detail.timend,
        staappr: this.detail.staappr,
        remark: this.detail.remark
      }
    },
    callSave () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.postHres83eReserveSave({ saveParams: this.saveParams(), searchParams: this.searchIndex })
        }
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// reserve.vue?8d252360